import React from 'react';
import { TeamNameText, TeamNameWrapper, TeamSide } from './TeamNameStyles';

interface IProps {
  teamName: string;
  isHomeTeam: boolean;
}

export const TeamName: React.FC<IProps> = (props) => {
  const { teamName, isHomeTeam } = props;
  return (
    <TeamNameWrapper>
      <TeamSide>{isHomeTeam ? 'Home team' : 'Away Team'}</TeamSide>
      <TeamNameText className={`${isHomeTeam ? 'home-team-name' : 'away-team-name'}`}>{teamName}</TeamNameText>
    </TeamNameWrapper>
  );
};
